import script from "./StatsView.vue?vue&type=script&setup=true&lang=js"
export * from "./StatsView.vue?vue&type=script&setup=true&lang=js"

import "./StatsView.vue?vue&type=style&index=0&id=cca4e986&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cca4e986"]])

export default __exports__